import(/* webpackMode: "eager" */ "/app/app/(app)/activities/page.tsx");
